enum TITLES {
  JUNIOR = 'titles.mathJunior',
  APPRENTICE = 'titles.mathApprentice',
  SCHOLAR = 'titles.mathScholar',
  MATHLETE = 'titles.mathlete',
  MAGICIAN = 'titles.mathemagician',
  SORCERER = 'titles.mathSorcerer',
  HOUSE_MEMBER = 'titles.houseOfMathMember',
}

export default function getUserTitle(
  level: number,
):
  | TITLES.JUNIOR
  | TITLES.APPRENTICE
  | TITLES.SCHOLAR
  | TITLES.MATHLETE
  | TITLES.MAGICIAN
  | TITLES.SORCERER
  | TITLES.HOUSE_MEMBER {
  switch (true) {
    case level < 6:
      return TITLES.JUNIOR
    case level < 11:
      return TITLES.APPRENTICE
    case level < 20:
      return TITLES.SCHOLAR
    case level < 25:
      return TITLES.MATHLETE
    case level < 30:
      return TITLES.MAGICIAN
    case level < 35:
      return TITLES.SORCERER
    case level >= 35:
      return TITLES.HOUSE_MEMBER
  }
  return TITLES.JUNIOR
}
